import { motion } from "framer-motion";
import { Stamp } from "@/components/fronk/Stamp";

const fadeUp = {
  initial: { opacity: 0, y: 18 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-80px" },
  transition: { duration: 0.6, ease: [0.22, 1, 0.36, 1] },
};

const STAFF = [
  {
    img: "/fronk/characters/employee-junior-trader.webp",
    role: "Junior Trader",
    emp: "EMP 0413",
    desc: "Shouts at the terminal until the chart apologizes.",
    note: "Requested a second monitor. Received a second stapler.",
  },
  {
    img: "/fronk/characters/employee-accountant.webp",
    role: "Accountant",
    emp: "EMP 0007",
    desc: "Counts every capsule twice. Trusts the pencil, tolerates the calculator.",
    note: "Has never once been off by a coin. Nobody checks.",
  },
  {
    img: "/fronk/characters/employee-compliance.webp",
    role: "Compliance",
    emp: "EMP 0099",
    desc: "Keeps a folder on everyone. The chairman file needs its own cabinet.",
    note: "Current open cases. One. It is the phone thing again.",
  },
  {
    img: "/fronk/characters/employee-intern.webp",
    role: "Intern",
    emp: "EMP 0300",
    desc: "Fastest legs on the floor. Carries forms, coffee and the occasional capsule.",
    note: "Promised a desk by Q3. The year was not specified.",
  },
  {
    img: "/fronk/characters/employee-cafeteria.webp",
    role: "Cafeteria",
    emp: "EMP 0056",
    desc: "Serves the fly special every day. Nobody has complained twice.",
    note: "The soup recipe is technically confidential.",
  },
  {
    img: "/fronk/characters/employee-mailroom.webp",
    role: "Mailroom",
    emp: "EMP 0001",
    desc: "Stuffs every distribution envelope by hand. Knows the tubes by sound.",
    note: "Has worked here longer than the building.",
  },
];

export const StaffGrid = () => {
  return (
    <section
      id="staff"
      className="olive-pattern relative overflow-hidden bg-[color:var(--paper-0)] py-16 sm:py-20 lg:py-28"
      data-testid="staff-section"
    >
      <div className="relative z-10 mx-auto w-full max-w-6xl px-4 sm:px-6 lg:px-8">
        <motion.div {...fadeUp}>
          <Stamp>Frog resources</Stamp>
          <h2 className="font-heading mt-5 max-w-2xl text-3xl font-bold leading-tight text-[color:var(--ink-900)] sm:text-4xl lg:text-5xl">
            The staff runs this place. FRONK mostly watches.
          </h2>
          <p className="font-body mt-4 max-w-xl text-base leading-relaxed text-[color:var(--ink-800)]">
            Six departments. One shared belief in the tubes. The outgoing
            currency changed to TOAD. The staff did not. Hover a badge to read
            the internal file.
          </p>
        </motion.div>

        <motion.div {...fadeUp} className="mt-10">
          <img
            src="/fronk/characters/pepe-employee-roster.webp"
            alt="Group photo of the Pepe employee roster"
            className="mx-auto w-full max-w-3xl"
            loading="lazy"
          />
          <p className="font-mono-ledger mt-2 text-center text-[10px] uppercase tracking-[0.2em] text-[color:var(--ink-700)]">
            Department photo. Fiscal year of the tube.
          </p>
        </motion.div>

        <div
          className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3"
          data-testid="staff-grid"
        >
          {STAFF.map((s, i) => (
            <motion.article
              key={s.emp}
              initial={{ opacity: 0, y: 22 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{
                duration: 0.5,
                delay: (i % 3) * 0.1,
                ease: [0.22, 1, 0.36, 1],
              }}
              whileHover={{ rotate: -0.6 }}
              className="group relative overflow-hidden rounded-2xl border border-[color:var(--hairline)] bg-[color:var(--paper-0)] shadow-[var(--paper-lift)]"
              data-testid={`staff-card-${i}`}
            >
              <div className="flex h-52 items-end justify-center overflow-hidden border-b-2 border-[color:var(--ink-800)] bg-[color:var(--paper-2)]">
                <img
                  src={s.img}
                  alt={`${s.role} employee`}
                  className="h-44 object-contain drop-shadow-md transition-transform duration-300 group-hover:-translate-y-1 group-hover:scale-[1.03]"
                  loading="lazy"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center justify-between">
                  <h3 className="font-heading text-xl font-bold text-[color:var(--ink-900)]">
                    {s.role}
                  </h3>
                  <span className="font-mono-ledger rounded-md border border-[color:var(--ink-800)] px-2 py-0.5 text-[10px] tracking-[0.14em] text-[color:var(--ink-800)]">
                    {s.emp}
                  </span>
                </div>
                <p className="font-body mt-2 text-sm leading-relaxed text-[color:var(--ink-800)]">
                  {s.desc}
                </p>
                <div className="max-h-20 overflow-hidden transition-[max-height] duration-300 lg:max-h-0 lg:group-hover:max-h-20">
                  <p className="font-mono-ledger mt-3 border-t border-dashed border-[color:var(--hairline)] pt-3 text-[11px] uppercase leading-relaxed tracking-[0.1em] text-[color:var(--stamp-600)]">
                    Internal file: {s.note}
                  </p>
                </div>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};
